import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos(fornecedorId) {
        return axiosJwt.get(`${api}/fornecedores/${fornecedorId}/usuarios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(fornecedorId, id) {
        return axiosJwt.get(`${api}/fornecedores/${fornecedorId}/usuarios/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPerfisAcesso(fornecedorId) {
        return axiosJwt.get(`${api}/fornecedores/${fornecedorId}/usuarios/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirUsuario(fornecedorId, usuario) {
        return axiosJwt.post(`${api}/fornecedores/${fornecedorId}/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarUsuario(fornecedorId, usuario) {
        return axiosJwt.put(`${api}/fornecedores/${fornecedorId}/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfisAcesso(fornecedorId, usuarioPerfisAcesso) {
        return axiosJwt.post(`${api}/fornecedores/${fornecedorId}/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfilAcesso(fornecedorId, usuarioPerfilAcesso) {
        return axiosJwt.patch(`${api}/fornecedores/${fornecedorId}/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfisAcesso(fornecedorId, usuarioPerfisAcesso) {
        return axiosJwt.patch(`${api}/fornecedores/${fornecedorId}/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ativarDesativarUsuario(fornecedorId, usuarioId) {
        return axiosJwt.patch(`${api}/fornecedores/${fornecedorId}/usuarios/${usuarioId}/ativardesativar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    resetarSenhaUsuario(fornecedorId, usuarioId) {
        return axiosJwt.patch(`${api}/fornecedores/${fornecedorId}/usuarios/${usuarioId}/resetarsenha`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
